import { render, staticRenderFns } from "./VerticalBanner.vue?vue&type=template&id=f78117d4&scoped=true&"
import script from "./VerticalBanner.vue?vue&type=script&lang=js&"
export * from "./VerticalBanner.vue?vue&type=script&lang=js&"
import style0 from "./VerticalBanner.vue?vue&type=style&index=0&id=f78117d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78117d4",
  null
  
)

export default component.exports